import { DaoModel } from '@dynameat/models';

export class MenuGridItem extends DaoModel {
  constructor(guid, name, type, textAlt1, textAlt2, textAlt3, image, menuSection, menuGridConfiguration, menuGridItemConfiguration) {
    super(guid);
    this.name = name;
    this.type = type;
    this.textAlt1 = textAlt1 || '';
    this.textAlt2 = textAlt2 || '';
    this.textAlt3 = textAlt3 || '';
    this.image = image || null;
    this.menuSection = menuSection || null;
    this.menuGridConfiguration = menuGridConfiguration;
    this.menuGridItemConfiguration = menuGridItemConfiguration || null;
  }

  static toInstance(props = {}) {
    return new MenuGridItem(props.guid, props.name, props.type, props.text_alt1, props.text_alt2,
      props.text_alt3, props.image, props.menu_section, props.menu_grid_configuration, props.menu_grid_item_configuration);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      type: this.type,
      text_alt1: this.textAlt1,
      text_alt2: this.textAlt2,
      text_alt3: this.textAlt3,
      image: this.image,
      menu_section: this.menuSection,
      menu_grid_configuration: this.menuGridConfiguration,
      menu_grid_item_configuration: this.menuGridItemConfiguration
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('name', this.name);
    formData.append('type', this.type);
    formData.append('text_alt1', this.textAlt1);
    formData.append('text_alt2', this.textAlt2);
    formData.append('text_alt3', this.textAlt3);
    formData.append('menu_grid_configuration', this.menuGridConfiguration);

    if (this.menuSection) {
      formData.append('menu_section', this.menuSection);
    }

    if (this.menuGridItemConfiguration) {
      formData.append('menu_grid_item_configuration', this.menuGridItemConfiguration);
    }

    if (this.image instanceof File) {
      if (this.image.size !== 0) {
        formData.append('image', this.image, this.image.name);
      }
    } else if (!this.image) {
      formData.append('image', '');
    }

    return formData;
  }
}
